export default __webpack_public_path__ + "static/media/client.e6344540.webp";